import React, { useState } from 'react'
import styles from './TaskCard.module.scss'
import OpenTaskCard from './OpenTaskCard/OpenTaskCard'
import { dateFormat } from 'helpers/date'
import { ReactComponent as EditIcon } from 'components/UI/icons/edit-line.svg'
import asideModalStore from 'Stores/asideModalStore'
import EditDate from '../../../ContentBox/Global/GlobalModalSingle/templates/CRM/EditDate/EditDate'

const TaskCard = ({
  taskCategories,
  allTasks,
  setAllTasks,
  translate,
  ...task
}) => {
  const [cardOpen, setCardOpen] = useState(false)
  const [formData, setFormData] = useState({
    deal: task?.deal,
    task_category: task?.task_category,
    finish_task: null,
  })

  const onclickHandler = () => setCardOpen(!cardOpen)

  const toggleCardOpen = () => setCardOpen(!cardOpen)

  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex?.slice(1, 3), 16)
    const g = parseInt(hex?.slice(3, 5), 16)
    const b = parseInt(hex?.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  const getDateStatus = () => {
    if (!task.finish_task) return null

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const finishDate = new Date(task.finish_task)
    finishDate.setHours(0, 0, 0, 0)

    const timeDiff = finishDate.getTime() - today.getTime()

    if (timeDiff < 0) return 'overdue'
    if (timeDiff === 0) return 'today'
    return 'future'
  }

  const dateStatus = getDateStatus()

  const onBeforeAddTask = (formData) => {
    const { date, start_at, finish_at } = formData

    const result = {
      ...formData,
      status: 1,
      creator: formData?.assignee,
    }

    const startTime = start_at || '06:00:00'
    const endTime = finish_at || '23:00:00'

    result.start_task = new Date(`${date}T${startTime}`).toISOString()
    result.finish_task = new Date(`${date}T${endTime}`).toISOString()

    delete result.start_at
    delete result.finish_at
    delete result.date

    return result
  }

  const editDate = () => {
    const ms = {
      modalBodyComponent: () => <EditDate />,
      crm: true,
      button: translate.save,
      is_put: true,
      isResponsive: true,
      link: `tasktracker/tasks/${task?.id}`,
      title: 'Редактировать задачу',
      onBeforeSubmit: onBeforeAddTask,
      onSubmitSuccess: (data) => {
        if (data) {
          setAllTasks((prevTasks) =>
            prevTasks.map((task) =>
              task.id === data.id ? { ...task, ...data } : task,
            ),
          )
        }
      },
      valid: {
        date: 'required',
      },
    }
    const md = {
      deal: task.deal.id,
      assignee: task.assignee.id,
      task_category: task.task_category.id,
      finish_task: task.finish_task,
      start_task: task.start_task,
      comment: task.comment,
    }
    asideModalStore.activity(ms, md)
  }

  return (
    <div
      className={`${styles.taskCardContainer} ${dateStatus ? styles[dateStatus] : ''}`}
    >
      <div className={styles.typeStatusAndFullNameBlock}>
        <a
          className={styles.taskName}
          href={`/crm/customer-card/${task?.deal?.id}/?funnel_id=${task?.deal?.funnels[0]?.id}`}
          target='_blank'
        >
          {task?.title}
        </a>
        <div className={styles.typeTaskStatusInfo}>
          <div
            className={styles.typeFunnelStatus}
            style={{
              backgroundColor:
                task?.deal?.funnels[0]?.deal_status?.color?.body_color || '',
            }}
          >
            {task?.deal?.funnels[0]?.deal_status?.name}
          </div>
        </div>
      </div>
      <div className={styles.typeTaskColumn}>
        <div>
          <div className={`${styles.fullName} ${styles.typeTaskInfo}`}>
            <span>{translate.name}:</span>

            <a
              className={styles.link}
              href={`/crm/customer-card/${task?.deal?.id}/?funnel_id=${task?.deal?.funnels[0]?.id}`}
            >
              <span className={styles.value}>
                {task?.deal?.deal_name || ''}
              </span>
            </a>
          </div>
          <div
            className={`${styles.typeTaskInfo}`}
            style={{ cursor: 'pointer' }}
            onClick={editDate}
          >
            <span>{translate.performer}:</span>
            <span className={styles.value}>
              {task?.assignee.name}
              <EditIcon className={styles.editDateBlock} />
            </span>
          </div>
          <div
            className={`${styles.typeTaskInfo}`}
            style={{ cursor: 'pointer' }}
            onClick={editDate}
          >
            <span>{translate.finish_date}:</span>
            <span className={styles.value}>
              {task?.finish_task
                ? dateFormat(
                    new Date(task.finish_task).toISOString(),
                    'hh:ii dd.mm.YYYY',
                  )
                : '—'}
              <EditIcon className={styles.editDateBlock} />
            </span>
          </div>
        </div>
      </div>
      <div className={styles.typeTaskAndDateBlock}>
        <div className={styles.typeTaskAndBtn}>
          <div className={styles.btns}>
            <div
              className={styles.typeTaskStatusInfo}
              style={{ cursor: 'pointer' }}
              onClick={editDate}
            >
              <div
                className={styles.typeTask}
                style={{
                  backgroundColor: task?.task_category?.color?.body_color
                    ? hexToRgba(task.task_category.color.body_color, 0.2)
                    : '',
                }}
              >
                <img src={task?.task_category?.text_file} alt='icon' />
                <span
                  style={{
                    color: task?.task_category?.color?.body_color
                      ? task.task_category.color.body_color
                      : '',
                  }}
                >
                  {task?.task_category?.name}
                </span>
              </div>
            </div>
            <div className={styles.statusBlock} onClick={onclickHandler}>
              <div className={styles.statusTitle}>Статус:</div>
              <div style={{ cursor: 'pointer' }} className={styles.statusValue}>
                <div>{task?.status?.name}</div>
                <EditIcon className={styles.editDateBlock} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {cardOpen && (
        <OpenTaskCard
          currentTask={task}
          formData={formData}
          setFormData={setFormData}
          taskCategories={taskCategories}
          onClose={toggleCardOpen}
          allTasks={allTasks}
          setAllTasks={setAllTasks}
          setCardOpen={setCardOpen}
        />
      )}
    </div>
  )
}

export default TaskCard
